<template>
  <div class="dashboard-style">
    <div class="card">
      <div class="card-body">
        <div class="containerFormular">
          <div class="headline-text">
            Verfügbare Artikel hochladen
          </div>
          <div
            class="basic-text"
            align="center"
          >
            Hier finden Sie die Möglichkeit, Ihre Artikel mit der baooCloud zu synchronisieren. <br>
            Bitte laden Sie dazu eine .csv Datei hoch, welche die Artikel EAN sowie den jeweiligen Preis beinhaltet. <br>
            Ein Beispiel ist hier zu finden: Beispiel CSV
          </div>
          <form
            action="#"
            @submit.prevent="submit"
          >
            <div class="section-text">
              Artikelliste
            </div>
            <div class="centered-fileupload">
              <input
                type="file"
                name="ImageURL"
                class="eingabefeld"
                accept=".csv"
                required
                @change="onFilePicked"
              >
              <div class="dateiUploadInfo">
                Artikelliste muss eine .csv Datei sein.
              </div>
              <template slot="error">
                File type is invalid.
              </template>
            </div>

            <div class="submit">
              <input
                type="submit"
                name="abgesendet"
                class="submitbutton-small"
                value="hinzufügen"
              >
            </div>
          </form>
          <notifications
            group="upload-notifications"
            position="center bottom"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import firebase from "firebase";
    import Papa from "papaparse";

    const onlyDigitsRegEx = /^\d+$/;
    const priceRegex = /(?:\d+\.)?\d+,\d{2}/;

    export default {
        data() {
            return {
                statusText: "",
                csvUpload: {
                    fileName: null,
                    fileURL: null,
                    csvFile: null
                },
                csvUploadInfo: "",
                showDismissibleAlert: false,
                error: null,
                csvParserOptions: {
                    delimiter: ";",	// auto-detect
                    newline: "\n",	// auto-detect
                    header: false,
                    step: this.onProcessCSVLine,
                    complete: this.onCSVProcessComplete,
                    error: undefined,
                    skipEmptyLines: true,
                },
                currentLine: 0
            };
        },
        computed: {
            // map `this.user` to `this.$store.getters.user`
            ...mapGetters({
                user: "user"
            })
        },
        methods: {
            sanitizeInput({ data }){
                // sanitizing the input fails if
                // the line contains more than two columns OR
                // if the ean has any other length then 8 or 13 or is no only digits OR
                // the price does not match the price regex
                if(data.length > 2) throw Error("Bitte überprüfen Sie die Anzahl der Spalten in der CSV Datei.");
                if((data[0].length !== 8 && data[0].length !== 13)) throw Error("EAN ungültig.");
                if(!onlyDigitsRegEx.test(data[0])) throw Error("EAN ungültig.");
                if(data[1].startsWith("0")) throw Error("Preis darf nicht mit '0' beginnen.");
                if(!priceRegex.test(data[1])) throw Error("Fehler bei der Preisvalidierung.");
                return {
                    ean: data[0].trim(),
                    price: data[1].trim()
                }
            },
            async uploadArticleData({ data }){
                const userId = firebase.auth().currentUser.uid;
                await firebase.database().ref('/retailer/' + userId + "/productrange/" + data.ean + "/price").set(data.price);
            },
            clearCSVData() {
                this.csvUpload.fileName = "";
                this.csvUpload.csvFile = null;
                this.csvUpload.fileURL = "";
                document.forms[0].elements[0].value = '';
                this.currentLine = 0;

            },
            onProcessCSVLine(results){
                this.currentLine += 1;
                if(results.errors.length > 0) return;
                try{
                    const sanitizedItem = this.sanitizeInput({ data: results.data });
                    this.uploadArticleData({ data: sanitizedItem })
                } catch(e) {
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `Zeile ${this.currentLine}: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                    this.clearCSVData();
                }
            },
            onCSVProcessComplete(){
                this.$notify({
                    group: 'upload-notifications',
                    title: 'Erfolg!',
                    text: 'Ihre Artikel wurden mit der baooCloud synchronisiert!',
                    type: 'success',
                    duration: 5000,
                });
                this.clearCSVData();
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.csvUpload.fileName = files[0].name;
                    if (this.csvUpload.fileName.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        this.csvUpload.fileURL = fr.result;
                        this.csvUpload.csvFile = files[0]; // this is an image file that can be sent to server
                        const fileSize = this.csvUpload.csvFile.size; // in kb
                        if(fileSize > 1000000) {
                            console.log(`CSV Datei zu groß! Maximal 1mb (1000kb) erlaubt.`);
                            this.error = `CSV Datei zu groß! Maximal 1mb (1000kb) erlaubt.`;
                            this.showDismissibleAlert = true;
                            this.clearCSVData();
                        }
                    });
                } else {
                    this.clearCSVData();
                }
            },
            async processCSVFile() {
                // parse csv file
                Papa.parse(this.csvUpload.csvFile, this.csvParserOptions);
            },
            async submit() {
                try {
                    await this.processCSVFile();
                } catch (e){
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                    this.clearCSVData();
                    return;
                }
            }
        }
    };
</script>